import { getSelectedProjectId, getRenderingOrder, getLastKnownBounds } from 'owa-timestream-store';
import { getProjectPreviewId } from 'owa-timestream-projectmanager';
import { ASSUMED_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { computed } from 'mobx';
import max from '../util/max';
import min from '../util/min';

const computedAssetsBoundingRect = computed(() => {
    const projectId = getProjectPreviewId() ?? getSelectedProjectId();
    return getRenderingOrder(projectId).reduce(
        (a, assetId) => {
            const bounds = getLastKnownBounds(projectId, assetId);
            if (bounds) {
                const { x: left, y: top, width, height } = bounds;
                const bottom = top + (height || ASSUMED_ASSET_WIDTH);
                const right = left + (width || ASSUMED_ASSET_WIDTH);
                a.top = min(top, a.top);
                a.left = min(left, a.left);
                a.bottom = max(bottom, a.bottom);
                a.right = max(right, a.right);
            }
            return a;
        },
        { top: NaN, left: NaN, bottom: NaN, right: NaN }
    );
});

export default function getAssetsBoundingRect() {
    return computedAssetsBoundingRect.get();
}
